<div class="bottom-sheet-inner allowance-sheet allowance-sheet--fixed">
  <div class="allowance-sheet-sticky-top">
    <div class="bottom-sheet-handle"></div>
    <div class="allow-head d-flex ion-align-items-start">
      <div class="allow-head-copy flex-1">
        <div class="allow-title font800 dutyfree-text-color">
          {{ 'dutyfree.retail_cart.allowance_sheet_title' | translate }}
        </div>
        <div class="dutyfree-text-secondary fs-3 mart4">{{ subtitle }}</div>
      </div>
      <button
        type="button"
        class="allow-x df-plain d-flex ion-align-items-center ion-justify-content-center cursor-pointer"
        (click)="close()"
        [attr.aria-label]="'modals.generic_alert.close' | translate"
      >
        <ion-icon name="close-outline" class="font20"></ion-icon>
      </button>
    </div>
  </div>

  <div class="allowance-sheet-scroll df-sheet-scroll ion-content-scroll-host">
    <div class="dest-prompt padt14" *ngIf="showDestinationPicker">
      <div
        class="dest-prompt-lead fs-2 dutyfree-text-secondary marb12 l-height150"
        [innerHTML]="'dutyfree.retail_cart.allowance_dest_lead' | translate"
      ></div>
      <div class="dest-prompt-search-wrap">
        <div class="dest-prompt-search d-flex ion-align-items-center card-white-background-color padl10 padr10 dutyfree-text-muted">
          <ion-icon name="search-outline" class="font18 dutyfree-text-secondary"></ion-icon>
          <input
            type="text"
            class="dest-prompt-input flex-1 fs-3 dutyfree-text-color ion-no-padding"
            [placeholder]="'dutyfree.retail_cart.allowance_dest_search_placeholder' | translate"
            [value]="destSearchQuery"
            (input)="filterDestCountries($event)"
          />
        </div>
        <div
          class="dest-prompt-results card-white-background-color ion-content-scroll-host"
          *ngIf="filteredDestCountries.length && destSearchQuery"
        >
          <button
            type="button"
            class="dest-prompt-result df-plain d-flex ion-align-items-center w100 ion-text-start cursor-pointer pad10 grey-border-bottom dutyfree-text-color"
            *ngFor="let country of filteredDestCountries"
            (click)="selectDestination(country)"
          >
            <span class="dest-prompt-code fs-2 font700 dutyfree-text-color">{{ country.code }}</span>
            <span class="dest-prompt-name flex-1 fs-3 font600 dutyfree-text-color">{{ country.name }}</span>
          </button>
        </div>
      </div>
      <div class="dest-prompt-chips d-flex mart10">
        <button
          type="button"
          class="dest-prompt-chip d-flex ion-align-items-center cursor-pointer card-white-background-color dutyfree-text-color fs-3 font600"
          *ngFor="let country of popularDestCountries"
          [class.selected]="destination?.countryCode === country.code"
          (click)="selectDestination(country)"
        >
          <span class="dest-prompt-flag fs-1 font700 dutyfree-text-muted pad5 border-r2">{{ country.code }}</span>
          <span class="dest-prompt-chip-label fs-3 font600">{{ country.name }}</span>
        </button>
      </div>
    </div>

    <ng-container *ngIf="showMeters">
      <div class="allow-row d-flex ion-align-items-center grey-border-top" *ngIf="destination">
        <ion-icon name="location-outline" class="allow-row-icon font18 dutyfree-text-secondary"></ion-icon>
        <div class="allow-row-copy flex-1">
          <div class="fs-2 dutyfree-text-secondary">
            {{ (destinationLocked
                ? 'dutyfree.retail_cart.allowance_arriving_in_locked'
                : 'dutyfree.retail_cart.allowance_arriving_in') | translate }}
          </div>
          <div class="fs-4 font700 dutyfree-text-color mart4">
            {{ destination.countryName }}
          </div>
        </div>
        <ng-container *ngIf="!destinationLocked; else lockedBadge">
          <button
            type="button"
            class="allow-change df-plain fs-3 font700 dutyfree-accent-color cursor-pointer"
            (click)="onChangeDestination($event)"
          >
            {{ 'dutyfree.retail_cart.allowance_change' | translate }}
          </button>
        </ng-container>
        <ng-template #lockedBadge>
          <span class="allow-locked-badge d-flex ion-align-items-center">
            <ion-icon name="lock-closed-outline" class="font14 dutyfree-text-muted"></ion-icon>
          </span>
        </ng-template>
      </div>
      <div
        class="allow-locked-note d-flex ion-align-items-center mart8 pad8"
        *ngIf="destinationLocked"
      >
        <ion-icon name="lock-closed-outline" class="font14"></ion-icon>
        <span class="fs-1 font600 flex-1 l-height150">
          {{ 'dutyfree.retail_cart.allowance_country_locked_arrival' | translate }}
        </span>
      </div>

      <!-- Travelling together / multiple travellers hidden until backend support
      <div class="allow-row d-flex ion-align-items-center grey-border-top">
        <ion-icon name="person-outline" class="allow-row-icon font18 dutyfree-text-secondary"></ion-icon>
        <div class="allow-row-copy flex-1">
          <div class="fs-2 dutyfree-text-secondary">
            {{ 'dutyfree.retail_cart.allowance_travelling_together' | translate }}
          </div>
          <div class="fs-4 font700 dutyfree-text-color mart4">{{ travellerLabel }}</div>
        </div>
        <div class="allow-step d-flex ion-align-items-center border-r10">
          <button
            type="button"
            class="allow-step-btn df-plain d-flex ion-align-items-center ion-justify-content-center cursor-pointer"
            [disabled]="travellerCount <= 1"
            (click)="changeTravellers(-1)"
            [attr.aria-label]="'dutyfree.retail_cart.allowance_remove_traveller' | translate"
          >
            <ion-icon name="remove-outline" class="font18"></ion-icon>
          </button>
          <span class="allow-step-val fs-4 font800 ion-text-center dutyfree-text-color">{{ travellerCount }}</span>
          <button
            type="button"
            class="allow-step-btn df-plain d-flex ion-align-items-center ion-justify-content-center cursor-pointer"
            [disabled]="travellerCount >= maxTravellerCount"
            (click)="changeTravellers(1)"
            [attr.aria-label]="'dutyfree.retail_cart.allowance_add_traveller' | translate"
          >
            <ion-icon name="add-outline" class="font18"></ion-icon>
          </button>
        </div>
      </div>
      -->
    </ng-container>

    <div class="allow-skel" *ngIf="isLoading">
      <div class="allow-meter" *ngFor="let _ of skeletonMeterItems">
        <div class="d-flex ion-align-items-baseline ion-justify-content-between marb8">
          <ion-skeleton-text animated class="allow-skel-label d-block border-r4"></ion-skeleton-text>
          <ion-skeleton-text animated class="allow-skel-value d-block border-r4"></ion-skeleton-text>
        </div>
        <ion-skeleton-text animated class="allow-skel-bar d-block w100"></ion-skeleton-text>
        <ion-skeleton-text animated class="allow-skel-note d-block mart8"></ion-skeleton-text>
      </div>
    </div>

    <ng-container *ngIf="showMeters">
      <div
        class="allow-empty d-flex flex-col ion-align-items-center ion-justify-content-center ion-text-center"
        *ngIf="showEmptyState"
      >
        <div class="allow-empty-icon d-flex ion-align-items-center ion-justify-content-center">
          <ion-icon [name]="emptyStateIcon" class="font35"></ion-icon>
        </div>
        <div class="fs-5 font700 dutyfree-text-color mart10">
          {{ emptyStateTitle }}
        </div>
        <div class="fs-2 dutyfree-text-secondary mart6 l-height150">
          {{ emptyStateHint }}
        </div>
        <button
          type="button"
          class="allow-empty-action df-plain fs-2 font700 dutyfree-accent-color mart16 cursor-pointer"
          *ngIf="showUnavailableState && !destinationLocked"
          (click)="onChangeDestination($event)"
        >
          {{ 'dutyfree.retail_cart.allowance_unavailable_change' | translate }}
        </button>
      </div>

      <div class="allow-group" *ngFor="let group of groups">
        <div
          class="allow-group-head d-flex ion-align-items-baseline ion-justify-content-between"
          *ngIf="group.label"
        >
          <span class="font11 font700 ion-text-uppercase dutyfree-text-muted l-spacing0">
            {{ group.label }}
          </span>
          <span class="font11 font500 dutyfree-text-secondary ion-text-end" *ngIf="group.hint">
            {{ group.hint }}
          </span>
        </div>
        <div
          class="allow-meter"
          *ngFor="let item of group.items"
          [class.focused]="isFocused(item)"
        >
          <div class="allow-meter-head d-flex ion-align-items-baseline ion-justify-content-between marb8">
            <span class="allow-meter-label fs-4 font700 d-flex flex-1 ion-align-items-center">
              {{ categoryLabel(item) }}
              <span
                class="allow-tag font11 font700"
                [attr.data-state]="state(item)"
                *ngIf="tagLabel(item) as tag"
              >{{ tag }}</span>
            </span>
            <span class="allow-meter-value fs-3 text-no-wrap">
              <span class="font800 dutyfree-text-color">{{ usedText(item) }}</span>
              <span class="dutyfree-text-muted font500"> / {{ allowedText(item) }}</span>
            </span>
          </div>
          <div class="allow-bar" [attr.data-state]="state(item)">
            <i [style.width.%]="progress(item)"></i>
            <span
              class="allow-bar-tick"
              *ngIf="item.exceeded"
              [style.left.%]="limitPercent(item)"
            ></span>
          </div>
          <div class="allow-meter-note fs-2 font500 dutyfree-text-muted mart8">
            {{ note(item) }}
          </div>
        </div>
      </div>

      <div class="allow-terms grey-border-top" *ngIf="hasMeters">
        <button
          type="button"
          class="allow-terms-head df-plain d-flex ion-align-items-center w100 ion-text-start cursor-pointer"
          (click)="toggleTerms()"
          [attr.aria-expanded]="termsOpen"
        >
          <span class="flex-1 fs-3 font700 dutyfree-text-color">
            {{ 'dutyfree.retail_cart.allowance_terms_title' | translate }}
          </span>
          <span class="fs-2 font500 dutyfree-text-muted">{{ termsCount }}</span>
          <ion-icon
            name="chevron-down-outline"
            class="allow-terms-chev font18 dutyfree-text-muted"
            [class.open]="termsOpen"
          ></ion-icon>
        </button>
        <div class="allow-terms-body" [class.open]="termsOpen">
          <div class="allow-terms-inner">
            <div class="allow-note d-flex ion-align-items-start">
              <span class="allow-note-dot"></span>
              <span class="fs-2 l-height150">
                {{ 'dutyfree.retail_cart.allowance_pax_note' | translate }}
                {{ 'dutyfree.retail_cart.allowance_disclaimer' | translate }}
              </span>
            </div>
            <div class="allow-note d-flex ion-align-items-start" *ngFor="let rule of rules">
              <span class="allow-note-dot"></span>
              <span class="fs-2 l-height150">{{ rule }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="allowance-sheet-footer" *ngIf="hasDestination || showMeters">
    <div class="allow-help d-flex ion-align-items-start" *ngIf="hasMeters || showEmptyState">
      <ion-icon name="information-circle-outline" class="font16"></ion-icon>
      <span class="fs-2 l-height150">
        {{ 'dutyfree.retail_cart.allowance_help_only' | translate }}
      </span>
    </div>
    <ion-button expand="block" class="allow-done w100 mar0" (click)="onDone()">
      {{ 'dutyfree.retail_cart.allowance_done' | translate }}
    </ion-button>
  </div>
</div>
